import { render } from "./IAChatPanel.vue?vue&type=template&id=187129b4&scoped=true&ts=true"
import script from "./IAChatPanel.vue?vue&type=script&lang=ts"
export * from "./IAChatPanel.vue?vue&type=script&lang=ts"

import "./IAChatPanel.vue?vue&type=style&index=0&id=187129b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187129b4"]])

export default __exports__